export default __webpack_public_path__ + "cc1813ee948a9b5acc92b401a3e6ae9b.png";